import { render } from "./UserPicker.vue?vue&type=template&id=48498412&scoped=true&ts=true"
import script from "./UserPicker.vue?vue&type=script&lang=ts"
export * from "./UserPicker.vue?vue&type=script&lang=ts"

import "./UserPicker.vue?vue&type=style&index=0&id=48498412&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48498412"]])

export default __exports__